export enum ImportModalPage {
  Upload = "new",
  ImportSuccess = "success",
  ImportError = "error",
  ImportHistory = "history",
  ImportDataTable = "details"
}
